import { render, staticRenderFns } from "./ModalAcademyData.vue?vue&type=template&id=fd9bd13e&scoped=true&lang=pug&"
import script from "./ModalAcademyData.vue?vue&type=script&lang=ts&"
export * from "./ModalAcademyData.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAcademyData.vue?vue&type=style&index=0&id=fd9bd13e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9bd13e",
  null
  
)

export default component.exports